import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MessageScrollerButtonDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import type {
    MessageScrollerButtonDirection
} from "../../type";
import {
    getElevationStyle
} from "../../../../helpers/theme/elevation";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

export const MESSAGE_SCROLLER_BUTTON_LABEL_KEYS: Record<MessageScrollerButtonDirection, keyof NCoreUIKit.Translation> = {
    start: "go-to-first-message",
    end: "go-to-latest-message"
};

export const MESSAGE_SCROLLER_BUTTON_EDGES: Record<MessageScrollerButtonDirection, "bottom" | "top"> = {
    end: "bottom",
    start: "top"
};

const stylesheet = StyleSheet.create({
    container: {
        pointerEvents: "box-none",
        position: "absolute",
        alignItems: "center",
        start: 0,
        end: 0
    },
    surface: {
        alignSelf: "center"
    }
});

export const useStyles = ({
    shapeConfigs,
    shadowAlpha,
    elevations,
    direction,
    radiuses,
    colors,
    spaces
}: MessageScrollerButtonDynamicStyleType) => {
    const styles = {
        container: {
            [MESSAGE_SCROLLER_BUTTON_EDGES[direction]]: spaces.spacingMd,
            zIndex: shapeConfigs.layers.raised + 1
        } as Mutable<ViewStyle>,
        surface: {
            ...getCornerStyle({
                radius: radiuses.actions,
                shapeConfigs
            }),
            ...getElevationStyle({
                shadowColor: colors.system.shadow,
                level: "level2",
                shadowAlpha,
                elevations
            })
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
